import React from "react";
import classNames from "classnames";
import BookingPrintServices from "./BookingPrintServices";
import { siteUrl } from "../../config";
// import BookingAcceptRules from "./BookingAcceptRules";

function BookingFormCardPrices({
  booking,
  hoteldata,
  booking_step = false,
  footer = <></>,
  acceptRules = false,
  setAcceptRules = null,
}) {
  return (
    <div className="bookingCard bookingCard__dates tar mob_hide">
      <div className="bookingCard__dates">
        <div className="prices__box one">
          <div className="dfsp">
            <div className="tal">
              <p>Проживание</p>
            </div>
            <div>
              {booking.prices.living +
                booking.selectedTariffs.reduce(
                  (total, obj) => total + obj.price_sum,
                  0,
                ) +
                booking.selectedAdditionalTariffs.reduce(
                  (total, obj) => total + obj.price_sum,
                  0,
                )}{" "}
              ₽
            </div>
          </div>
          <div className="pricesBox__tariffs">
            <p>{hoteldata.room_name}</p>
            {booking.selectedTariffs?.length > 0 &&
              booking.selectedTariffs.map((tariff) => (
                <p key={`st${tariff.name}`}>
                  {tariff.name}
                  {/* <span>
                {tariff.price_sum === 0
                  ? "бесплатно"
                  : tariff.price_sum}{" "}
                ₽
              </span> */}
                </p>
              ))}
            {booking.selectedAdditionalTariffs?.length > 0 &&
              booking.selectedAdditionalTariffs.map((tariff) => (
                <p key={`sat${tariff.name}`}>
                  {tariff.name}
                  {/* <span>
                {tariff.price_sum === 0 ? (
                  "бесплатно"
                ) : (
                  <>{tariff.price_sum}</>
                )}{" "}
                ₽
              </span> */}
                </p>
              ))}
          </div>
          <div className="dfsp mt6">
            <div className="tal">
              <p>Услуги</p>
            </div>
            <div>
              {booking.selectedServices.reduce(
                (total, obj) => total + obj.sum,
                0,
              )}{" "}
              ₽
            </div>
          </div>
          <div className="pricesBox__tariffs nop">
            <BookingPrintServices booking={booking} />
          </div>
        </div>
        <p className="bookingCard__total dfsp">
          <span className="tal">Итого</span>{" "}
          <span>{booking.prices.total} ₽</span>
        </p>
        <div className="prices__box two">
          <p className="bookingCard__prepay dfsp">
            <span className="txt">Предоплата</span>{" "}
            <span className="vl">{booking.prices.prepayment} ₽</span>
          </p>
          <p className="dfsp">
            <span className="txt">Оплата на месте</span>
            <span className="vl">{booking.prices.payment_on_spot} ₽</span>
          </p>
          <p
            className={classNames("bookingCard__cancelPrice dfsp", {
              red: booking.prices.cancel_fee > 0,
            })}
          >
            <span className="txt">Отмена брони</span>
            <span className="vl">
              {booking.prices.cancel_fee === 0
                ? "бесплатная"
                : `${booking.prices.cancel_fee} ₽`}
            </span>
          </p>
        </div>
      </div>
      {booking_step && (
        <div className="bookingInfo tal pl12">
          <div className="mt6">
            <input
              type="checkbox"
              name="rules"
              checked={acceptRules}
              onChange={() => setAcceptRules((prev) => !prev)}
            />{" "}
            Соглашаюсь с обработкой персональных данных и{" "}
            <a
              target="_blank"
              href={`${siteUrl}/pages/privacy`}
              rel="noopener noreferrer"
            >
              политикой конфиденциальности
            </a>
            .
          </div>
          {hoteldata?.reservation_request && (
            <div className="info">
              Наличие номеров на запрошенные вами даты не гарантируется,
              обязательно дождитесь подтверждения вашей заявки владельцем отеля
            </div>
          )}
        </div>
      )}
      <div>{footer}</div>
    </div>
  );
}

export default BookingFormCardPrices;
